import LoggingIcon from '@mui/icons-material/EmojiPeopleTwoTone';
import AutomationRequestsList from './AutomationRequestsList';

export default {
    list: AutomationRequestsList,
    icon: LoggingIcon
}